module.exports = __webpack_public_path__ + "static/img/search_no_data.9cd65e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/search_no_data.png
// module id = 5S5G
// module chunks = 19